export enum OrganizationUsersActionTypes {
  ResendInvite = 'organizationUsers/resendInvite',
  RequestOrganizationUsers = 'organizationUsers/requestOrganizationUsers',
  ToggleFiltersPopUp = 'organizationUsers/toggleFiltersPopUp',
  ResetState = 'organizationUsers/resetState',
}
